
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M19 3h-6.528c-.154 0-.31-.036-.447-.105L8.869 1.317a3.017 3.017 0 00-1.341-.316H5A5.004 5.004 0 000 6v12c0 2.757 2.243 5 5 5h1a1 1 0 100-2H5c-1.654 0-3-1.346-3-3V9h20v9c0 1.654-1.346 3-3 3h-1a1 1 0 100 2h1c2.757 0 5-2.243 5-5V8c0-2.757-2.243-5-5-5zM2 6c0-1.654 1.346-3 3-3h2.528c.154 0 .31.036.447.105l3.156 1.578c.415.207.878.316 1.341.316H19c1.302 0 2.402.839 2.816 2H2v-1zm13.707 13.105a.999.999 0 010 1.414l-1.613 1.613c-.577.577-1.335.865-2.094.865s-1.516-.288-2.093-.865l-1.614-1.613a.999.999 0 111.414-1.414L11 20.398V13a1 1 0 112 0v7.398l1.293-1.293a.999.999 0 011.414 0z"}})])
          )
        }
      }
    